import * as swcHelpers from '@swc/helpers';
import React__default, { useContext } from 'react';

const IntlContext = /*#__PURE__*/ React__default.createContext({});
const useIntl = ()=>useContext(IntlContext)
;
function withIntl(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithIntl = (props)=>/*#__PURE__*/ React__default.createElement(IntlContext.Consumer, null, (context)=>/*#__PURE__*/ React__default.createElement(Component, swcHelpers.extends({}, props, {
                intl: context
            }))
        )
    ;
    WithIntl.displayName = `WithIntl(${wrappedName})`;
    return WithIntl;
}
var IntlContext$1 = IntlContext;

export { IntlContext$1 as default, useIntl, withIntl };
//# sourceMappingURL=IntlContext.js.map
